export default __webpack_public_path__ + "static/media/painting-service.6943093d.jpg";